export const NOTIFICATION_PREFERENCE_KEYS = [
	'newApplications',
	'essays',
	'feedback',
	'documents',
	'lorRequests',
	'lorUploaded',
	'assignments',
	'messages',
]

export const DEFAULT_NOTIFICATION_PREFERENCES = Object.fromEntries(
	NOTIFICATION_PREFERENCE_KEYS.map(key => [key, true]),
)

export const BELL_ROW_ID_BY_KEY = {
	newApplications: 'shortlist',
	essays: 'essay_review',
	feedback: 'essay_feedback',
	documents: 'documents',
	lorRequests: 'lor_requests',
	lorUploaded: 'lor_uploaded',
	assignments: 'assignments',
	messages: 'student_chat',
}

export const APPLICATIONS_NAV_BADGE_KEYS = [
	'newApplications',
	'essays',
	'feedback',
	'documents',
	'lorRequests',
	'lorUploaded',
]

export const ASSIGNMENTS_NAV_BADGE_KEY = 'assignments'

export const MESSAGES_NAV_BADGE_KEY = 'messages'

export const RAW_COUNT_KEY_BY_PREFERENCE_KEY = {
	newApplications: 'newApplications',
	essays: 'essays',
	feedback: 'feedback',
	documents: 'documents',
	lorRequests: 'lorRequests',
	lorUploaded: 'lorUploaded',
	assignments: 'assignments',
	messages: 'messagesUnreadTotal',
}
